import Btn, { BtnProps } from "../Btn";
import Img from "../Img";

interface BannerProps {
    img: string;
    title: string;
    subtitle: string;
    button: string;
    buttonProps?: BtnProps
}


const Banner = ({ img, title, subtitle, button, buttonProps }: BannerProps): JSX.Element => {
    return (
        <div className="Banner w-full min-h-[280px] h-[280px] flex middle pr-2 mt-20 mb-10 overflow-hidden relative">
            {/* <div className="absolute z-20 bottom-8 right-2 text-white md:text-black md:static TextContent flex flex-col gap-3 min-w-[300px] pr-2"> */}
            <div className="absolute z-20 top-1/2 -translate-y-1/2 md:translate-y-0 right-2 text-white md:text-black md:static TextContent flex flex-col gap-3 min-w-[300px] pr-2">
                <h1>{title}</h1>
                <p className="text-gray-100 md:text-gray-500">{subtitle}</p>
                <Btn defaultStyle noBgBlur
                    {...(buttonProps ?? {})}
                    className="mt-5"
                >{button}</Btn>
            </div>
            <div className="ImgContent grow h-full rounded-l-lg overflow-hidden">
                <Img
                    src={img}
                    alt={"Banner image"}
                    className="w-full h-full brightness-75 md:brightness-100"
                />
            </div>
        </div>
    )
}

export default Banner